// agriflow/core/static/core.js

import PdfSettings from "./module/PdfSettings";
import * as bootstrap from 'bootstrap';

export default class coreCompanys{

    constructor(){
        this.events();
    }

    events(){
        const superUser = document.querySelector('#superuser');
        if(superUser){
            this.fetchData();
            superUser.addEventListener('click', this.updateCompany.bind(this));
        }
    }

    async fetchData() {
        try {
            const response = await fetch(companyList, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    
            if (!response.ok) {
                //console.warn(`Zugriff verweigert oder keine Daten verfügbar. Status: ${response.status}`);
                return; 
            }
    
            const data = await response.json();
            if (!data || data.length === 0) {
          
                return; // Nichts weiter machen, wenn keine Daten vorhanden sind
            }
            const container = document.querySelector('#superuser');
            data.forEach(item => {
                const element = document.createElement('div');
                element.innerHTML = `
                    <li><a class="dropdown-item" data-superuser="${item.id}" href="#">${item.company}</a></li>
                `;
                container.appendChild(element);
            });

        } catch (error) {
            console.error('Es gab ein Problem mit der Fetch-Operation:', error);
        }
    }

    async updateCompany(event) {
        if (event.target.classList.contains('dropdown-item')) {
            const companyId = event.target.getAttribute('data-superuser');
            const csrfToken = getCookie('csrftoken');
            const updateUrl = updateSuperuserCompany.replace('0', companyId);
            console.log(updateUrl)
            try {
                const response = await fetch(updateUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRFToken': csrfToken
                    },
                    body: JSON.stringify({ company: companyId })
                });
    
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
    
                const data = await response.json();
                location.reload();
            } catch (error) {
                console.error('Es gab ein Problem mit der Update-Operation:', error);
            }
        }
    }


}

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; cookies.length > i; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

document.addEventListener('DOMContentLoaded', function () {
    const corecompanys = new coreCompanys();
    const pdfsettings = new PdfSettings();



    const numberrangeForm = document.getElementById('numberrangeForm');
    if (numberrangeForm) {

        const saveButton = document.querySelector('#submit-id-save');
        if (saveButton) {
            saveButton.disabled = true;
        }
        numberrangeForm.onsubmit = function(e) {
            e.preventDefault();
            
            const prefix = document.getElementById('id_prefix').value;
            const year = document.getElementById('id_year').value;
            const prefix_special = document.getElementById('id_prefix_special_char').value;
            const year_special = document.getElementById('id_year_special_char').value;
            
            const fertigeNummer = `${prefix}${prefix_special}${year}${year_special}`;
            
            const modal = new bootstrap.Modal(document.getElementById('previewModal'));
            document.getElementById('previewContent').innerHTML = `
                <p>Die Nummer wird so aussehen:</p>
                <h4>${fertigeNummer}</h4>
                <p>Beispiel: ${fertigeNummer}001</p>
            `;
            modal.show();
            document.getElementById('saveButton').onclick = function() {
                numberrangeForm.submit();
            };
        };
    
    }


});

